import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHead } from "./SectionHead";
import { bonuses } from "../data/landing";
export function BonusesSection() {
  return <section id="bonuses" className="bg-white py-16 md:py-24" data-id="element-1" data-mp="vswcubwrb3ic">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-2" data-mp="vu7f27ak037c">
        <SectionHead eyebrow={`Included with your kit · ${bonuses.length} bonuses`} title="Plus 5 bonuses to" highlight="run your program." lead="Extra resources to prepare, schedule, and open your sessions." data-id="element-3" data-mp="qtjp7oy29sep" />
        <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-4" data-mp="zsn92v51ybu9">
          {bonuses.map((bonus, i) => <li key={bonus.title} className="flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-[0_10px_30px_rgba(19,34,56,0.07)]" data-id="element-5" data-mp="19kkoke33fpys" data-mpi={i}>
              <div className="relative" data-id="element-6" data-mp="1jiqpasd5yq22">
                <img src={bonus.image} alt={`${bonus.title} cover`} className="aspect-square w-full object-cover" loading="lazy" data-id="element-7" data-mp="1jjs334lkdqnh" />
                <span className="absolute left-3 top-3 rounded-md bg-navy px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-teal-bright" data-id="element-8" data-mp="3psohq7osa5n5">
                  Bonus {i + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4" data-id="element-9" data-mp="7l8h1704zkr7">
                <h3 className="font-display text-[22px] font-bold uppercase leading-[1.05] text-navy" data-id="element-10" data-mp="7m0b2de35afd">{bonus.title}</h3>
                <p className="mt-2 text-sm text-ink/80" data-id="element-11" data-mp="gldp7jd5mn6f">{bonus.text}</p>
              </div>
            </li>)}
        </ul>
        <div className="mt-12 text-center" data-id="element-12" data-mp="lbu1h058o2r7">
          <CtaButton href="#offer-details" className="w-full sm:w-auto" data-id="element-13" data-mp="lcvnfznsm9np">
            Get the kit + 5 bonuses
          </CtaButton>
        </div>
      </div>
    </section>;
}